import {poll, PollPayload, pollSingle} from "../api/AlfyApiClient";
import {useSetRecoilState} from "recoil";
import {QueryClient, useMutation} from "react-query";
import {QUERY_KEYS} from "../states/query-keys";
import {PollSingleRequest} from "../models/request/poll";
import {useFetchAppointmentWithPoll} from "../states/appointment/server";
import {pollSelectedAbsentDateState, pollSelectedAttendDateState} from "../states/poll/pollAtom";

export const useAlfyApi = () => {

    const useAnswerAskAttendance = (appointmentId: string) => {
        const queryClient = new QueryClient()
        const { refetch: refetchAppointment } = useFetchAppointmentWithPoll(appointmentId)

        return useMutation(async (request: PollSingleRequest) =>
            {
                return await pollSingle(request)
            },
            {
                onSuccess: () => {
                    queryClient.removeQueries([QUERY_KEYS.APPOINTMENT, appointmentId])
                    refetchAppointment()
                }
            })
    }


    const usePollMultiple = (appointmentId: string) => {
        const queryClient = new QueryClient()
        const setPollSelectedAbsentDates = useSetRecoilState(pollSelectedAbsentDateState);
        const setPollSelectedAttendDates = useSetRecoilState(pollSelectedAttendDateState);

        const { refetch: refetchAppointment } = useFetchAppointmentWithPoll(appointmentId)

        return useMutation(async (request: PollPayload[]) =>
            {
                return await poll(appointmentId, request)
            },
            {
                onSuccess: () => {
                    queryClient.removeQueries([QUERY_KEYS.APPOINTMENT, appointmentId])
                    setPollSelectedAbsentDates([])
                    setPollSelectedAttendDates([])
                    refetchAppointment()
                },
                onError: (error) => {
                    console.error(error)
                    throw error
                },

            })
    }

    return {
        useAnswerAskAttendance,
        usePollMultiple,
    }

}